<template>
  <div id="app">
    <AppNavbar />

    <main class="page-content">
      <HeroSection />
      <PartnersClient />
      <AppServices />
      <HowItWorks />
      <AppPortofolio />
      <AboutUs />
      <TeamSection />
      <CTASection />
      <ContactDetails />
    </main>

    <AppFooter />
  </div>
</template>

<script>
import AppNavbar from "./components/AppNavbar.vue";
import HeroSection from "./components/HeroSection.vue";
import PartnersClient from "./components/PartnersClient.vue";
import AppServices from "./components/AppServices.vue";
import HowItWorks from "./components/HowItWorks.vue";
import AppPortofolio from "./components/AppPortofolio.vue";
import ContactDetails from "./components/ContactDetails.vue";
import AboutUs from "./components/AboutUs.vue";
import AppFooter from "./components/AppFooter.vue";
import CTASection from "./components/CTASection.vue";

export default {
  components: {
    AppNavbar,
    HeroSection,
    PartnersClient,
    AppServices,
    HowItWorks,
    AppPortofolio,
    AboutUs,
    CTASection,
    ContactDetails,
    AppFooter,
  },
};
</script>

<style>
#app {
  min-height: 100vh;
}

.page-content {
  overflow: hidden;
}
</style>
